module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCxc4AMP6lbBP.52c68e97.woff2";